module.exports = __webpack_public_path__ + "img/icon-arrow-below-20@3x.025c93f3.png";